import { axiosWithAuth } from "../../helpers";

export const boardingFormService = {
	getBoardingDetailView,
	getQADetailView,
	rejectBoardingApplication,
	doneBoardingApplication,
	qaCompleteBoardingApplication,
	midClaimBoardingApplication,
	isCheckMpaDocument,
	viewFullMpaDocument,
	triggerAutoBoarding,
};

const API_URL = process.env.REACT_APP_API_URL;

function getBoardingDetailView(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/boarding/${id}`,
	};

	return axiosWithAuth(options);
}

function getQADetailView(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/boarding/qa/${id}`,
	};

	return axiosWithAuth(options);
}

function rejectBoardingApplication({ applicationId, reason }) {
	const options = {
		url: `${API_URL}/api/applications/boarding/${applicationId}/reject`,
		method: "POST",
		data: { reason },
	};

	return axiosWithAuth(options);
}

function doneBoardingApplication(applicationId, outcome) {
	const options = {
		url: `${API_URL}/api/applications/boarding/${applicationId}/complete`,
		data: { boarding_outcome: outcome },
		method: "POST",
	};

	return axiosWithAuth(options);
}

function qaCompleteBoardingApplication({ applicationId, qaResult, qaComment }) {
	const options = {
		method: "POST",
		data: { qa_result: qaResult, qa_comment: qaComment },
		url: `${API_URL}/api/applications/boarding/qa/${applicationId}/complete`,
	};

	return axiosWithAuth(options);
}

function midClaimBoardingApplication(applicationId, mid) {
	const options = {
		url: `${API_URL}/api/applications/boarding/${applicationId}/${mid}/claim`,
		method: "POST",
	};

	return axiosWithAuth(options);
}

function isCheckMpaDocument(applicationId) {
	let user = JSON.parse(localStorage.getItem("user"));

	const options = {
		url: `${API_URL}/api/applications/${applicationId}/view_mpa?token=${user.access_token}`,
		method: "GET",
	};

	return axiosWithAuth(options);
}

function viewFullMpaDocument(applicationId) {
	let user = JSON.parse(localStorage.getItem("user"));
	window.open(
		`${API_URL}/api/applications/${applicationId}/view_mpa?token=${user.access_token}`,
		"_blank",
	);
}

function triggerAutoBoarding({ applicationId }) {
	const options = {
		url: `${API_URL}/api/applications/boarding/${applicationId}/auto`,
		method: "POST",
	};

	return axiosWithAuth(options);
}
